import { dateFormat } from "helpers/common";
import { useEffect, useState } from "react";
import { Button, Col, Dropdown, Form, Row } from "react-bootstrap";

import rightArrow from "Assets/images/rightArro.png"
import downArrow from "Assets/images/downArrowPurple.png"
import downArrowNormal from 'Assets/images/downArrowBlack.png'
import upArrow from "Assets/images/upArrowPurple.png"
import { DIAGNOSIS_SERVERITY, NOTES_TABLE } from "config/paths";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import LoadingOverlay from "components/shared/LoadingOverlay";
import AddNotesCollaboratorsModal from "components/Modals/AddNotesCollaborators";
import { useGetClinicalImpressionsListQuery, useGetDiagnosisListQuery } from "store/services/resource";
import parse from "html-react-parser"
import { CstmPagination } from "components/Common/Common";


const DiagnosisComponent = ({ client_id, clientType, isPage = false, setClientDetails }) => {
  const navigate = useNavigate()
  const [currentEntry, setCurrentEntry] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [diagnosisIndex, setDiagnosisIndex] = useState({})
  const [page, setPage] = useState(1);
  const rowsPerPage = 5; // you can set 3, 5, 10 etc.



  // notes
  // const { data: daignosis, isLoading, isFetching } = useGetDiagnosisListQuery({ id: client_id, moduleName: module, limit: 3 }, { skip: !client_id });

  const { data: daignosis, isLoading, isFetching } = useGetClinicalImpressionsListQuery({ id: client_id, limit: 3 }, { skip: !client_id });

  const [sortField, setSortField] = useState("date"); // date | type
  const [sortOrder, setSortOrder] = useState("desc"); // asc | desc


  const sortedDiagnosis = daignosis
    ? [...daignosis].sort((a, b) => {

      let valueA = "", valueB = "";

      if (sortField === "date") {
        valueA = new Date(a?.updatedAt || a?.assessment_date);
        valueB = new Date(b?.updatedAt || b?.assessment_date);
      }

      if (sortField === "type") {
        valueA = a?.assesments?.assesmentType?.title?.toLowerCase() || "";
        valueB = b?.assesments?.assesmentType?.title?.toLowerCase() || "";
      }

      if (sortField === "discipline") {
        valueA = a?.assesments?.Therapist?.therapist_detail?.therapist_discipline?.assign_term?.toLowerCase() || "";
        valueB = b?.assesments?.Therapist?.therapist_detail?.therapist_discipline?.assign_term?.toLowerCase() || "";
      }

      if (sortField === "description") {
        const descA = a?.answer?.answer || a?.diagnosis_severity?.answer || "";
        const descB = b?.answer?.answer || b?.diagnosis_severity?.answer || "";
        valueA = String(descA).toLowerCase();
        valueB = String(descB).toLowerCase();
      }

      if (sortOrder === "asc") {
        return valueA > valueB ? 1 : -1;
      } else {
        return valueA < valueB ? 1 : -1;
      }
    })
    : [];


  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc"); // toggle
    } else {
      setSortField(field);
      setSortOrder("desc");
    }
  };


  const totalPages = Math.ceil(sortedDiagnosis.length / rowsPerPage);

  const paginatedData = sortedDiagnosis.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setPage(page);
  };

  useEffect(() => {
    if (daignosis?.[0]?.assesments?.ClientDetails && typeof (setClientDetails) == 'function') {
      setClientDetails(daignosis?.[0]?.assesments?.ClientDetails)
    }
  }, [daignosis])


  return (
    <>
      {<div className="w-100">
        <AddNotesCollaboratorsModal
          show={showModal}
          setShow={setShowModal}
          therapists={currentEntry?.therapists}
          noteTableId={currentEntry?.id}
        // therapists={values?.therapistData || []}
        // type="delete"
        // confirmHandler={handleDelete}
        />
        {(isFetching) && <LoadingOverlay />}
        <div style={{ border: !isPage && "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
          {
            !isPage &&
            <Row>
              <Col lg='8'>
                <h6 className="mb-0 proxima-regular" style={{ marginTop: "3px", fontSize: '15px' }}>
                  CLINICAL IMPRESSIONS
                  <span onClick={() => navigate(generatePath(DIAGNOSIS_SERVERITY, { clientType, clientId: client_id }))} className="themePurple cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span>
                </h6>
              </Col>
              {/* <Col lg='4' className="text-end">
              <svg onClick={() => navigate(generatePath(NOTES_TABLE, { clientType: "school", clientId: client_id, moduleName: module }))} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" className="mx-1"><mask id="mask0_0_12941" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{ maskType: "alpha" }}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_0_12941)"><path d="M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z" fill="#93278F"></path></g></svg>
            </Col> */}
            </Row>
          }
          <div className="mt-2">
            <table className="w-100">
              <thead className="color-black">
                <tr>
                  <th onClick={() => handleSort("date")} className={`fw-medium  text-dark ${sortField == 'date' && "themePurple cursor-pointer"}`} style={{ width: "10%", padding: "15px 10px", fontSize: "15px", borderBottom: "2px solid #315D99", }}>
                    DATE
                    <img width={9} height={9} className="ms-2" src={sortField === "date" ? sortOrder === "asc" ? upArrow : downArrow : downArrowNormal} alt="downArrow" />
                  </th>
                  <th className={`fw-medium  ${sortField == 'type' && "themePurple cursor-pointer"}`} onClick={() => handleSort("type")} style={{ padding: "15px 10px", fontSize: "15px", borderBottom: "2px solid #315D99", width: "15%", }}>
                    REPORT TYPE
                    <img width={9} height={9} className="ms-2" src={sortField === "type" ? sortOrder === "asc" ? upArrow : downArrow : downArrowNormal} alt="downArrow" />
                  </th>
                  <th onClick={() => handleSort("discipline")} className={`fw-medium  text-center ${sortField == 'discipline' && "themePurple cursor-pointer"}`} style={{ padding: "15px 10px", fontSize: "15px", borderBottom: "2px solid #315D99", width: "15%", }} >DISCIPLINE
                    <img width={9} height={9} className="ms-2" src={sortField === "discipline" ? sortOrder === "asc" ? upArrow : downArrow : downArrowNormal} alt="downArrow" />
                  </th>
                  <th onClick={() => handleSort("description")} className={`fw-medium  ${sortField == 'description' && "themePurple cursor-pointer"}`} style={{ padding: "15px 10px", fontSize: "15px", borderBottom: "2px solid #315D99", }} >DESCRIPTION
                    <img width={9} height={9} className="ms-2" src={sortField === "description" ? sortOrder === "asc" ? upArrow : downArrow : downArrowNormal} alt="downArrow" />
                  </th>
                  <th className="fw-medium " style={{ padding: "15px 10px", fontSize: "15px", borderBottom: "2px solid #315D99" }} ></th>
                </tr>
              </thead>
              <tbody className="color-black">
                {
                  sortedDiagnosis?.length > 0 ? paginatedData?.map((item, index) => {
                    return ((isPage || index < 3) &&
                      <tr>
                        <td className="table-inner-text" style={{ padding: "15px 10px", fontSize: "15px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{dateFormat(item?.updatedAt || item?.assessment_date, "MMM D, YYYY")}</td>
                        <td className=" " style={{ padding: "15px 10px", fontSize: "15px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                          {item?.assesments?.assesmentType?.title}
                        </td>
                        <td className="text-center mr-2 table-inner-text" style={{ padding: "15px 10px", fontSize: "15px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                          <span className={`discipline-${item?.assesments?.Therapist?.therapist_detail?.therapist_discipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.assesments?.Therapist?.therapist_detail?.therapist_discipline?.assign_term}</span>
                        </td>
                        <td className="table-inner-text" style={{ padding: "15px 10px", fontSize: "15px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                          <div className={`${!diagnosisIndex[index] && !isPage && "html-truncate"}`}>
                            {item?.answer?.answer ? item?.answer?.answer : parse(item?.diagnosis_severity?.answer || "")}
                          </div>
                        </td>
                        <td className="text-center table-inner-text" style={{ padding: "15px 10px", fontSize: "15px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                          {!isPage &&
                            <div
                              className="cursor-pointer d-flex align-items-center"
                              style={{ padding: "10px 10px" }}
                              onClick={(e) => {
                                e.stopPropagation(); // prevent row navigation
                                setDiagnosisIndex((prev) => ({ ...prev, [index]: prev[index] ? false : true }))
                              }}
                            >
                              {diagnosisIndex?.[index] ? (
                                <img width={12} src={downArrow} alt="Collapse" />
                              ) : (
                                <img width={7} src={rightArrow} alt="Expand" />
                              )}
                            </div>
                          }
                        </td>

                      </tr>
                    )
                  }) :
                    <tr>
                      <td colSpan={5}>
                        <div className="classroom-no-reports mt-2 p-1 w-100">
                          <p>No Record Found.</p>
                        </div>
                      </td>
                    </tr>
                }
              </tbody>
            </table>

          </div>
          {isPage && sortedDiagnosis.length > rowsPerPage && (
            <div className="mt-3">

              <CstmPagination
                totalPages={totalPages}
                className={'paginationV2'}
                activePage={page}
                handlePageChange={handlePageChange}
              />

            </div>
          )}
        </div>
      </div >}

    </>
  );

};

export default DiagnosisComponent;